import { Breadcrumbs, Container, Link, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import useIsMobile from 'shared/hooks/useIsMobile'
import { getPxAsRem } from 'shared/utils'

export default function BasicBreadcrumbs() {
    const navigate = useNavigate()
    const location = useLocation()
    const isMobile = useIsMobile()

    const handleClick = (event, path) => {
        event.preventDefault()
        navigate(path)
    }

    const pathnames = location.pathname.split('/').filter((x) => x)

    return (
        <Container
            sx={{
                paddingTop: getPxAsRem(isMobile ? 12 : 36),
            }}
        >
            <Breadcrumbs aria-label="breadcrumb">
                <Link
                    underline="hover"
                    color="inherit"
                    href="/"
                    onClick={(event) => handleClick(event, '/')}
                >
                    Home
                </Link>
                {pathnames.map((value, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join('/')}`

                    return index + 1 === pathnames.length ? (
                        <Typography color="text.primary" key={to}>
                            {value.charAt(0).toUpperCase() + value.slice(1)}
                        </Typography>
                    ) : (
                        <Link
                            underline="hover"
                            color="inherit"
                            href={to}
                            onClick={(event) => handleClick(event, to)}
                            key={to}
                        >
                            {value.charAt(0).toUpperCase() + value.slice(1)}
                        </Link>
                    )
                })}
            </Breadcrumbs>
        </Container>
    )
}
